import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BreadcrumbModule } from 'angular-crumbs';
import { NgwWowModule } from 'ngx-wow';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PreloaderComponent } from './preloader/preloader.component';
import { GlobalComponent } from './global/global.component';
import { SharedModule } from './components/shared/shared.module';
import { ParagraphsModule } from './components/paragraphs/paragraphs.module';
import { HighchartsChartModule } from 'highcharts-angular';
import * as Highcharts from 'highcharts/highcharts';
import HC_histogram from 'highcharts/modules/histogram-bellcurve';
HC_histogram(Highcharts);
import highcharts3D from 'highcharts/highcharts-3d';
highcharts3D(Highcharts);
// import theme from 'highcharts/themes/high-contrast-dark';
// theme(Highcharts);
// import theme1 from 'highcharts/themes/high-contrast-light';
// theme1(Highcharts);
import ItemSeries from 'highcharts/modules/item-series';
ItemSeries(Highcharts);

import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { SearchService } from './components/pages/home/search/search.service';
import { ToastrModule } from 'ngx-toastr';
import { OnlineStatusComponent } from './online-status/online-status.component';
import { APOLLO_OPTIONS, ApolloModule } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { InMemoryCache, from } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import { environment } from 'src/environments/environment';
@NgModule({
  declarations: [
    AppComponent,
    PreloaderComponent,
    GlobalComponent,
    OnlineStatusComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    BreadcrumbModule,
    NgbModule,
    HttpClientModule,
    NgwWowModule,
    SharedModule,
    ParagraphsModule,
    HighchartsChartModule,
    SweetAlert2Module.forRoot(),
    ToastrModule.forRoot(),
    ApolloModule,
  ],
  providers: [
    SearchService,
    {
      provide: APOLLO_OPTIONS,
      useFactory(httpLink: HttpLink) {
        return {
          cache: new InMemoryCache(),
          link: from([
            setContext((_, { headers }) => {
              return {
                headers: {
                  ...headers,
                  // 'User-Agent': `zscaler-marketing/${environment.USER_AGENT_KEY}`,
                },
              };
            }),
            httpLink.create({
              uri: environment.backend.baseURL + '/graphql/',
            }),
          ]),
        };
      },
      deps: [HttpLink],
    },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }
